import { render, staticRenderFns } from "./PolaroidImage.vue?vue&type=template&id=0b110288&scoped=true&"
import script from "./PolaroidImage.vue?vue&type=script&lang=js&"
export * from "./PolaroidImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b110288",
  null
  
)

export default component.exports